import { openDb } from './loadStore';

const STORE = 'reports';

function tx(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(r && r.result !== undefined ? r.result : r);
    t.onerror = () => reject(t.error);
  }));
}

export async function getReports() {
  const all = await tx('readonly', (os) => new Promise((res) => {
    const out = [];
    os.openCursor().onsuccess = (e) => { const c = e.target.result; if (c) { out.push(c.value); c.continue(); } else res(out); };
  }));
  return all.sort((a, b) => (b.day || '').localeCompare(a.day || '') || (b.deviceName || '').localeCompare(a.deviceName || ''));
}

export const saveReport = (r) => tx('readwrite', (os) => os.put(r));
export const reportExists = async (id) => !!(await tx('readonly', (os) => os.get(id)));
